import { render } from "./resources.vue?vue&type=template&id=68ae15a4"
import script from "./resources.vue?vue&type=script&lang=js"
export * from "./resources.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__